import './style.scss';
import React, {PropTypes} from 'react';
import ClassName from 'classnames';
import moment from 'moment';
import {serverToDisplayTime, serverDateFormat, serverTimeFormat} from 'app/lib/format';
import Barometer from './Barometer';
import $ from 'jquery';

const formatTimeSlot = (timeSlot) => {
    let end = serverToDisplayTime(timeSlot.end);
    let begin = serverToDisplayTime(timeSlot.begin);
    let duration = moment.duration(end).subtract(begin);
    let durationInQuarter = duration.hours() * 4 + Math.round(duration.minutes()/15);

    return {
        end, begin, duration, durationInQuarter,
        hist: timeSlot.hist,
        curr: timeSlot.curr
    };
};

const isBeforeNow = (timeSlot, day) => {
    return moment().isAfter(moment(day + ' ' + timeSlot.end, serverDateFormat + ' ' + serverTimeFormat));
};

const TimeSlot = ({timeSlot, onSelect, day, ...other}) => {
    let _node;
    const ts = formatTimeSlot(timeSlot);
    const style = {
        height: ts.durationInQuarter * 25
    };
    const classNames = [
        'timeSlot', `curr-${ts.curr}`,
        isBeforeNow(timeSlot, day) ? 'disabled' : '',
        ts.curr === 0 ? 'disabled' : ''
    ];

    const clickHandler = () => {
        if (ts.curr === 0) {
            return;
        }

        onSelect(`${ts.begin} - ${ts.end}`);
        $(_node).parents('.modal').closeModal();
    };

    return (
        <div className={ClassName(classNames)} style={style} onClick={clickHandler} ref={(r) => {_node = r;}}>
            <div className="begin-end">{ts.begin} - {ts.end} {ts.hist > 0 && ts.curr > 0 && <Barometer level={ts.hist} {...other} />}</div>
        </div>
    );
};

TimeSlot.propTypes = {
    timeSlot: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    day: PropTypes.string
};

export default TimeSlot;
